import React,{useRef,useEffect} from 'react'
import styled from 'styled-components'
import theme from './theme.js'
import SearchIcon from './icon-inline-search.js'
import useApp from './use-app-context.js'
import {domain} from '../../data/site.mjs'

const Header = ({

}) => {
  const type = 'text'
  const placeholder = 'Search ' + domain
  const search = useApp().search
  const isActive = true
  const inputRef = useRef()

  const onChange = e => {
    e.preventDefault()

    search.setText(e.target.value)
  }

  const inputProps = {
    type,
    placeholder,
    onChange,
    ref: inputRef
  }

  useEffect(() => {
    if (isActive && inputRef.current) {
      inputRef.current.focus()
    }
  },[isActive])

  return (
    <Container>
      <Icon/>
      <Input {...inputProps}/>
    </Container>
  )
}

const Container = styled.div`
  border-bottom: 2px solid rgba(0,0,0,.1);
  display: flex;
  align-items: center;
  padding: 0 ${theme.pad.small};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`

const Input = styled.input`
  border: none;
  width: 100%;
  height: 3em;
  font-size: ${theme.font.size.p};
  outline: 0;

  &::placeholder {
    color: rgba(0,0,0,.4);
  }

  &:focus {
    outline: none;

    &::placeholder {
      color: rgba(0,0,0,.2);
    }
  }
`

const Icon = styled(SearchIcon)`
  font-size: ${theme.font.size.p};
  margin-right: 1em;
`

export default Header